import './RiftChessModal.css'
import ssl1 from '../../assets/images/ssl1.png'
import ssl2 from '../../assets/images/ssl2.png'

export default function RiftChessModal({ isOpen, onClose }) {
  if (!isOpen) return null

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>What is RiftChess?</h2>
          <button className="modal-close" onClick={onClose}>×</button>
        </div>
        <div className="modal-body">
          <p>
            RiftChess is an innovative online chess platform that combines classic chess gameplay with modern competitive features. Where intuition matters more than memorization, and every player has a chance to triumph through creativity, tactical brilliance, and a touch of luck.
          </p>
          <div className="modal-screenshots">
            <div className="screenshot-container">
              <img src={ssl1} alt="Chess game showing tactical moves and piece positioning" className="screenshot" />
              <p className="screenshot-caption">Dynamic board with special squares appearing at random locations</p>
            </div>
            <div className="screenshot-container">
              <img src={ssl2} alt="Chess board with advanced move patterns and strategic play" className="screenshot" />
              <p className="screenshot-caption">Piece teleportation and mid-game promotions create tactical depth</p>
            </div>
          </div>
          <div className="modal-features">
            <h3>RiftChess Special Squares:</h3>
            <ul>
              <li><span className="special-square red">Red Squares (Death)</span> - Any piece ending its turn on a red square is eliminated. Appears every 3 moves, adding strategic tension to piece placement</li>
              <li><span className="special-square blue">Blue Squares (Teleport)</span> - Instantly teleport your piece to any empty square on the board. Appears every 7 moves, opening up impossible tactical combinations</li>
              <li><span className="special-square green">Green Squares (Promotion)</span> - Transform pieces mid-game: pawns to knights/bishops, knights/bishops to rooks, rooks to queens. Appears every 10 moves</li>
            </ul>
            <p><em>All special squares appear at random locations on the board.</em></p>
          </div>
        </div>
        <div className="modal-footer">
          <button className="modal-btn-primary" onClick={onClose}>
            Get Started
          </button>
        </div>
      </div>
    </div>
  )
}